<template>
  <div>
    <b-card
      class="mb-2 shadow bg-light"
      header="Nouveau carnet de mandats"
      header-text-variant="light"
      header-tag="h6"
    >
      <b-row>
        <b-col lg="2">
          <mh-input field="invoice" :table="table"></mh-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6">
          <b-row>
            <b-col lg="4">
              <mh-input
                field="numberOfWarrants"
                :table="table"
                @update="adaptUnitPrice()"
              ></mh-input>
            </b-col>
            <b-col lg="4">
              <mh-input
                field="unitaryPrice"
                :table="table"
                append="€"
                @update="adaptTotal()"
              ></mh-input>
            </b-col>
            <b-col lg="4">
              <mh-input
                label="Prix total"
                :table="table"
                field="totalPrice"
                inputClass="text-right"
                readonly
                append="€"
              ></mh-input>
            </b-col>
            <b-col lg="4">
              <mh-input v-if="sellersLoaded" field="sellers" :table="table">
              </mh-input>
            </b-col>
            <b-col lg="4">
              <mh-input field="commission" :table="table"> </mh-input>
            </b-col>
            <b-col lg="4">
              <mh-input field="orderDate" :table="table"> </mh-input>
            </b-col>
            <b-col lg="12">
              <mh-input field="etiquettes" :table="table"></mh-input>
            </b-col>
            
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="12">
              <mh-input field="note" :table="table"></mh-input>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="12">
          <b-button @click="save" variant="success">Confirmer</b-button>
          <b-button @click="$emit('cancel')" variant="danger" class="ml-3"
            >Annuler</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput.vue";
import sellers from "@/services/sellers.js";
import creditors from "@/services/creditors.js";
export default {
  props: ["id"],
  components: {
    MhInput,
  },

  data() {
    return {
      sellersLoaded: false,
      sellers: [],
      table: {
        invoice: {
          label: "Facturer cet achat",
          value: "yes",
          options: [
            {
              value: "yes",
              text: "oui",
            },
            {
              value: "no",
              text: "non",
            },
          ],
        },
        note: {
          label: "Note",
          type: "text",
          value: "",
        },
        numberOfWarrants: {
          label: "Nombre de mandats",
          type: "int",
          value: 10,
        },
        unitaryPrice: {
          label: "Prix unitaire",
          type: "float",
          value: "35.00",
        },
        totalPrice: {
          label: "Prix total",
          type: "float",
          value: "350.00"
        },
        orderDate: {
          label: "Date de commande",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
        },
        sellers: {
          label: "Vente attribuée à",
          type: "enum",
          value: 3,
          options: []
        },
        etiquettes: {
          label: "Vente d'étiquettes",
          value: 0,
          options: [
            {
              value: 0,
              text: "Pas de vente d'étiquettes",
            },
            {
              value: 1,
              text: "42 étiquettes au prix unitaire de 1 €",
            },
            {
              value: 2,
              text: "105 étiquettes au prix unitaire de 0.80 €",
            },
            {
              value: 3,
              text: "210 étiquettes au prix unitaire de 0.75 €",
            },
            {
              value: 4,
              text: "504 étiquettes au prix unitaire de 0.60 €",
            },
          ],
        },
        commission: {
          label: "Commissionnement",
          value: 50,
          options: [
            {
              value: 50,
              text: "50 %",
            },
            {
              value: 40,
              text: "40 %",
            },
            {
              value: 30,
              text: "30 %",
            },
            {
              value: 20,
              text: "20 %",
            },
            {
              value: 10,
              text: "10 %",
            },
            {
              value: 0,
              text: "0 %",
            },
          ],
        },
        expiredWarrants: {
          label: "Nombre de mandats expirés",
          value: null,
          type: "int",
        },
        unitaryPriceExpiredWarrant: {
          label: "Prix unitaire",
          value: "28.00",
          type: "float",
        },
        rebuyExpiredWarrants: {
          label: "Racheter les mandats expirés",
          value: "yes",
          options: [
            {
              value: "yes",
              text: "Racheter",
            },
            {
              value: "no",
              text: "Ne pas racheter",
            },
          ],
        },
      },
    };
  },
  computed: {
    
  },
  watch: {
    table: {
      handler: function (newValue) {
        this.sellers.forEach((element) => {
          if (element.ID == newValue.sellers.value) {
            this.table.commission.value = element.commission;
          }
        });
      },
      deep: true,
    },
  },
  created() {
    sellers.get().then((response) => {
      this.sellers = response.data;
      this.table.sellers = {
        label: "Vente attribuée à",
        value: 3,
        type: "enum",
        options: response.data.map((x) => {
          return {
            value: x.ID,
            text: x.prenom + " " + x.nom,
          };
        }),
      };
      this.sellersLoaded = true;
    });
    creditors.getExpired(this.id, true).then((response) => {
      this.table.expiredWarrants.value = response.data.total;
    });
  },
  methods: {
    adaptTotal() {
       this.table.totalPrice.value = (this.table.unitaryPrice.value * this.table.numberOfWarrants.value).toFixed(2);
    },
    adaptUnitPrice() {
      if (this.table.numberOfWarrants.value <= 10) {
        this.table.unitaryPrice.value = 35;
      } else if (this.table.numberOfWarrants.value <= 20) {
        this.table.unitaryPrice.value = 30;
      } else if (this.table.numberOfWarrants.value <= 30) {
        this.table.unitaryPrice.value = 25;
      } else if (this.table.numberOfWarrants.value <= 50) {
        this.table.unitaryPrice.value = 20;
      } else {
        this.table.unitaryPrice.value = 15;
      }
      this.table.unitaryPrice.value = Number(this.table.unitaryPrice.value).toFixed(2)
      this.adaptTotal();
    },
    save() {
      creditors.createNotebook(this.id, this.table).then(() => {
        this.$emit("cancel");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>